try {
  const Holocron = global.Holocron;
  const fallbackExternal = Holocron.getExternal && Holocron.getExternal({
    name: 'iguazu-rpc',
    version: '1.6.1'
  });
  const rootModuleExternal = global.getTenantRootModule && global.getTenantRootModule().appConfig.providedExternals['iguazu-rpc'];

  module.exports = fallbackExternal || (rootModuleExternal ? rootModuleExternal.module : () => {
    throw new Error('[client][axp-benefits-wrapper] External not found: iguazu-rpc');
  })
} catch (error) {
  const errorGettingExternal = new Error([
    '[client] Failed to get external fallback iguazu-rpc',
    error.message
  ].filter(Boolean).join(' :: '));

  errorGettingExternal.shouldBlockModuleReload = false;

  throw errorGettingExternal;
}
